import { mainApi } from "../api/root-api"
import { getSocialNetworks } from "../slices/infoSlice"

export const getInfo = (token) => {
  const headers = { headers: { Authorization: token } }
  return async (dispatch) => {
    await mainApi.get('/info', headers).then(resp => {
      dispatch(getSocialNetworks(resp.data))
    }).catch(err => {
      // Se ignora: los componentes ya tienen valores por default de contacto
    })
  }
}
